import { plural, SERVERS } from '../format';
import { useApp } from '../store';
import { THEMES, THEME_KEYS } from '../themes';
import { btn, head, mono } from '../ui';

export function Header() {
  const app = useApp();

  const locs = new Set(app.hosts.map(h => h.loc)).size;
  const detail = app.detailId ? app.hostById(app.detailId) : undefined;

  const titles: Record<string, [string, string]> = {
    dash: [
      'Обзор парка',
      `${plural(app.hosts.length, SERVERS)} Windows · ${locs} локаци${locs === 1 ? 'я' : locs < 5 ? 'и' : 'й'} · агент по HTTPS-опросу`
    ],
    fleet: ['Серверы', 'Группировка по загрузке CPU · клик по хосту добавляет его в массовый выбор'],
    detail: ['Сервер', detail?.name ?? '—'],
    commands: ['Массовое выполнение', 'PowerShell или CMD на выбранных хостах'],
    files: ['Передача файлов', 'Один пакет — на все выбранные хосты'],
    rdp: ['RDP', 'Мультиэкран: сетка сессий, .rdp-файлы и лаунчер'],
    net: ['Скорость канала', 'Speedtest по парку и профиль каналов'],
    tasks: ['Задачи', 'Расписание и история массовых операций'],
    alerts: ['Алерты', 'Инциденты и пороги срабатывания']
  };

  const [title, sub] = titles[app.screen] ?? ['Fleet Console', ''];

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 8,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '14px 18px',
        padding: '16px 30px',
        background: 'var(--bgFade)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid var(--line)'
      }}
    >
      <div style={{ flex: '1 1 260px', minWidth: 260, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <span style={{ ...head, fontSize: 19, fontWeight: 700, letterSpacing: '-0.02em' }}>{title}</span>
        <span style={{ fontSize: 12, color: 'var(--ink3)' }}>{sub}</span>
      </div>

      <ConnectionDot />

      <input
        className="focusAcc"
        value={app.search}
        onChange={e => app.setSearch(e.target.value)}
        placeholder="host, ip, роль…"
        style={{
          flex: '0 1 210px',
          minWidth: 130,
          boxSizing: 'border-box',
          padding: '8px 12px',
          borderRadius: 'var(--rs)',
          border: '1px solid var(--line)',
          background: 'var(--panel2)',
          color: 'var(--ink)',
          ...mono,
          fontSize: 12,
          outline: 'none'
        }}
      />

      <div
        style={{
          display: 'flex',
          gap: 4,
          padding: 3,
          borderRadius: 99,
          background: 'var(--panel2)',
          border: '1px solid var(--line)',
          flex: 'none'
        }}
      >
        {THEME_KEYS.map(key => {
          const on = app.theme === key;
          return (
            <button
              key={key}
              onClick={() => app.setTheme(key)}
              title={THEMES[key].hint}
              style={{
                ...btn,
                display: 'flex',
                alignItems: 'center',
                gap: 7,
                padding: '5px 11px',
                borderRadius: 99,
                fontSize: 11.5,
                fontWeight: 600,
                whiteSpace: 'nowrap',
                background: on ? 'var(--accSoft)' : 'transparent',
                color: on ? 'var(--ink)' : 'var(--ink3)'
              }}
            >
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  background: THEMES[key].vars['--acc']
                }}
              />
              {THEMES[key].label}
            </button>
          );
        })}
      </div>

      <button
        className="hov"
        onClick={app.toggleDensity}
        style={{
          ...btn,
          padding: '7px 12px',
          borderRadius: 'var(--rs)',
          border: '1px solid var(--line)',
          fontSize: 11.5,
          color: 'var(--ink2)',
          whiteSpace: 'nowrap'
        }}
      >
        {app.dense ? 'Плотно' : 'Свободно'}
      </button>
    </header>
  );
}

/** Индикатор живого канала: без него непонятно, свежие ли цифры на экране. */
function ConnectionDot() {
  const { connected, demo } = useApp();
  const label = connected ? (demo ? 'демо-парк' : 'онлайн') : 'нет связи';
  const color = connected ? (demo ? 'var(--warn)' : 'var(--ok)') : 'var(--bad)';
  return (
    <span
      title={
        connected
          ? demo
            ? 'Данные идут с сервера, но парк симулирован (DEMO=1)'
            : 'Данные идут с сервера в реальном времени'
          : 'Соединение с сервером потеряно — на экране последний известный срез'
      }
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        flex: 'none',
        fontSize: 11.5,
        color: 'var(--ink3)',
        whiteSpace: 'nowrap'
      }}
    >
      <span
        style={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          background: color,
          animation: connected ? undefined : 'blip 1.2s infinite'
        }}
      />
      {label}
    </span>
  );
}
